/* eslint-disable */
<template>
  <div>
    <div
      v-if="!loading"
      class="table-cadu"
      :style="$vuetify.breakpoint.xs ? { width: '100% !important' } : !custom ? { width: '798px !important' } : {}"
    >
      <v-row align="center" no-gutters>
        <v-col cols="auto" v-if="rows.length > 0 && showSelect && showSelectItens"> Exibir </v-col>
        <v-col cols="auto" v-if="rows.length > 0 && showSelect && showSelectItens">
          <v-select
            class="relative primary1--text"
            full-width
            color="primary1"
            item-color="primary1"
            :append-icon="'$vuetify.icons.chevron-down'"
            :items="items"
            @input="elementsPerPageFunc"
            v-model="elementsPerPage"
          />
        </v-col>
        <v-col cols="auto" v-if="rows.length > 0 && showSelect && showSelectItens"> resultados </v-col>
        <v-row
          v-if="showFiltro"
          :class="$vuetify.breakpoint.xs ? 'align-center justify-center' : 'align-end justify-end'"
        >
          <v-col cols="auto">
            <button-cadu @click="$emit('filtro-click')">
              FILTRAR
            </button-cadu>
          </v-col>
          <v-col cols="auto" @click="anexar" v-if="showAnexo && editar">
            <icon name="paperclip" :size="20" style="cursor: pointer;" tooltip="Anexar Documento" />
          </v-col>
          <v-col cols="auto" @click="$emit('download')" v-if="showDownload">
            <icon name="download" :size="20" style="cursor: pointer;" tooltip="Exportar" />
          </v-col>
        </v-row>
      </v-row>

      <transition name="fade">
        <v-row v-if="showSelected" class="selected">
          <v-col cols="auto">
            <div class="primary1--text font-weight-bold title">
              {{ selectedSizeComputed }}
            </div>
          </v-col>
          <v-row align="end" justify="end">
            <v-col cols="auto" v-if="botaoSelecionarLixeira">
              <button-rounded class="mr-9" @click="emitDeleteSelected()" iconName="trash" :iconSize="16" />
            </v-col>
            <v-col cols="auto" v-else-if="botaoBaixarTodos">
              <button-cadu class="mr-9" text="BAIXAR TODOS" @click="emitBaixarSelected()" />
            </v-col>
            <v-col cols="auto" v-else>
              <button-cadu class="mr-9" text="REENVIAR" @click="emitDeleteSelected()" />
            </v-col>
          </v-row>
        </v-row>
      </transition>

      <div
        @scroll="scrollEvent"
        class="table"
        :style="$vuetify.breakpoint.xs ? { width: '229px;', height: '100%;', overflow: 'auto' } : {}"
      >
        <table
          rules="groups"
          :style="$vuetify.breakpoint.xs ? { width: '229px;', height: '100%;', overflow: 'auto' } : {}"
        >
          <thead>
            <tr>
              <th v-if="showCheck">
                <label class="form-checkbox">
                  <input
                    :disabled="rows.length <= 0 || disabledCheckAll || !editar"
                    type="checkbox"
                    v-model="selectAll"
                    @click="selectAllChecks()"
                  />
                  <icon class="form-icon white--text" style="border-color: #60656c;" name="check" :size="16" />
                </label>
              </th>
              <th
                v-for="(col, index) in rowsHeader"
                :key="index"
                :style="
                  index === rowsHeader.length - 1
                    ? { 'min-width': larguraUltimoHeader != undefined ? `${larguraUltimoHeader}px` : '110px' }
                    : ''
                "
              >
                <div v-if="col.icon" style="cursor: pointer; display: inline-block;" @click="ordenaTabela(index)">
                  {{ col.text }} <icon style="transform: rotate(90deg);" :name="col.icon" :size="20" />
                </div>
                <div v-else>
                  <div v-if="col.tooltip">
                    <v-tooltip eager top>
                      <template v-slot:activator="{ on }">
                        <div v-on="on">
                          {{ col.text }}
                        </div>
                      </template>
                      <span>{{ col.tooltip }}</span>
                    </v-tooltip>
                  </div>
                  <div v-else>
                    {{ col.text }}
                  </div>
                </div>
                <div v-if="col == sortColumn" class="font-weight-bold"></div>
              </th>
            </tr>
          </thead>

          <tbody>
            <tr
              v-for="(row, index) in get_rows"
              v-show="(index < itemsLimit)"
              :key="index"
              @mouseover="hoverIndex = index"
              @mouseleave="hoverIndex = null"
              :name="'tabela_' + index"
            >
              <td v-if="showCheck">
                <label class="form-checkbox">
                  <input
                    type="checkbox"
                    v-model="selected"
                    :value="getValueCheck(index, row.id)"
                    :disabled="getDisabledCheck(row.id)"
                  />
                  <icon class="form-icon white--text" name="check" :size="16" />
                </label>
              </td>
              <td v-for="(r, indexRow) in rowsData[index]" :key="indexRow">
                <div v-if="isObject(r)">
                  <v-tooltip eager top>
                    <template v-slot:activator="{ on }">
                      <div v-on="on" :style="'color: ' + r.color">
                        {{ r.nome }}
                      </div>
                    </template>
                    <span v-if="![null, undefined, ''].includes(r.tooltipColuna)">{{ r.tooltipColuna }}</span>
                  </v-tooltip>
                </div>
                <div v-else>
                  {{ r }}
                </div>
              </td>
              <td class="pa-0 pl-2" v-if="iconArr.length > 0 || htmlArr.length > 0">
                <div v-if="iconArr[index] !== undefined">
                  <icon
                    :name="iconArr[index].name"
                    :class="iconArr[index].class"
                    :size="iconArr[index].size"
                    :tooltip="iconArr[index].tooltipName"
                    v-if="
                      iconArr[index] !== undefined &&
                      (hoverIndex !== index ? true : !showActionsLine(hoverIndex, index))
                    "
                  />
                </div>

                <div v-else-if="htmlArrTooltip.length > 0">
                  <v-tooltip eager top>
                    <template v-slot:activator="{ on }">
                      <div v-on="on">
                        <div
                          v-html="htmlArrTooltip[index].html"
                          v-if="
                            htmlArrTooltip.length > 0 &&
                            (hoverIndex !== index ? true : !showActionsLine(hoverIndex, index))
                          "
                        />
                      </div>
                    </template>
                    <span>{{ htmlArrTooltip[index].tooltipName }}</span>
                  </v-tooltip>
                </div>

                <div v-else>
                  <div
                    v-html="htmlArr[index]"
                    v-if="htmlArr.length > 0 && (hoverIndex !== index ? true : !showActionsLine(hoverIndex, index))"
                  />
                </div>

                <div
                  style="display: inline-flex;"
                  v-if="
                    (htmlArr.length > 0 || iconArr.length > 0) &&
                    (hoverIndex === index ? showActionsLine(hoverIndex, index) : false)
                  "
                >
                  <button-rounded
                    style="width: 26px;"
                    class="mr-1"
                    @click="$emit('clickButton', { index, selected: [row.id], type: 'view' })"
                    iconName="eye"
                    :name="arrName[0]"
                    :iconSize="16"
                    v-if="permicaoUnimedVisualizar(index)"
                  />
                  <button-rounded
                    style="width: 26px;"
                    class="mr-1"
                    @click="$emit('clickButton', { index, selected: [row.id], type: 'edit' })"
                    iconName="edit"
                    :name="arrName[1]"
                    :iconSize="16"
                    v-if="permicaoUnimedEditar(index)"
                  />
                  <button-rounded
                    style="width: 26px;"
                    class="mr-1"
                    @click="$emit('clickButton', { index, selected: [row.id], type: 'delete' })"
                    iconName="trash"
                    :name="arrName[2]"
                    :iconSize="16"
                    v-if="editar && (modoEditar || rotasHabilitas) && disabledButtons[2]"
                  />
                  <button-rounded
                    style="width: 26px;"
                    class="mr-1"
                    @click="$emit('clickButton', { index, selected: [row.id], type: 'recibo' })"
                    iconName="download"
                    :name="arrName[3]"
                    :tooltipName="tooltipName"
                    :iconSize="16"
                    v-if="disabledButtons[3]"
                  />
                  <button-rounded
                    style="width: 26px;"
                    @click="$emit('clickButton', { index, selected: [row.id], type: 'anexo' })"
                    iconName="paperclip"
                    :name="arrName[4]"
                    :iconSize="16"
                    v-if="editar && disabledButtons[4] && verificaContemAnexos(row)"
                  />
                  <button-rounded
                    style="width: 26px;"
                    @click="$emit('clickButton', { index, selected: [row.id], type: 'refresh' })"
                    iconName="refresh-cw"
                    :name="arrName[5]"
                    :iconSize="16"
                    tooltipName="Regerar token"
                    v-if="editar && disabledButtons[5]"
                  />
                  <block-button-rounded
                    style="width: 26px;"
                    @click="$emit('clickButton', { index, selected: [row.id], type: 'block' })"
                    tooltipName="Bloquear"
                    :name="arrName[6]"
                    v-if="editar && disabledButtons[6]"
                  />
                </div>
              </td>
            </tr>
          </tbody>
        </table>
        <div style="text-align: center;" v-if="rows.length == 0">{{ semRegistro }}</div>
      </div>
      <v-row align="start" justify="start" v-if="qtResultados > 0" class="mt-4">
        <v-col cols="auto" v-if="pagina >= 1">
          <div>Exibindo página {{ currentPage }} de {{ rowsLength }} {{ rowsLength > 1 ? 'páginas' : 'página' }}.</div>
        </v-col>
        <v-row
          v-if="pagina > 0 && qtPaginas > 0 && qtResultados > 0"
          :class="$vuetify.breakpoint.xs ? 'align-center justify-center' : 'align-end justify-end'"
          no-gutters
        >
          <v-col cols="auto">
            <button class="set" :disabled="currentPage === 1" @click="change_page(1)">
              <icon name="chevrons-left" :size="12" />
            </button>
            <button class="set" :disabled="currentPage === 1" @click="change_page(currentPage - 1)">
              <icon name="chevron-left" :size="12" />
            </button>
            <div
              class="number"
              v-for="(i, index) in num_pages()"
              :key="index"
              :class="[i === currentPage ? 'active' : '']"
              @click="change_page(i)"
            >
              {{ i }}
            </div>
            <button
              class="set"
              :disabled="currentPage === qtPaginas || qtPaginas === 0"
              @click="change_page(currentPage + 1)"
            >
              <icon name="chevron-right" :size="12" />
            </button>
            <button
              class="set"
              :disabled="currentPage === qtPaginas || qtPaginas === 0"
              @click="change_page(qtPaginas)"
            >
              <icon name="chevrons-right" :size="12" />
            </button>
          </v-col>
        </v-row>
      </v-row>
    </div>
    <component-loading :value="loading" />
    <v-row v-if="texto && (modoEditar || this.rotasHabilitas)">
      <v-col>
        <a @click="$emit('clickButton', { type: 'add' })" style="color: #1492e6;"> {{ texto }} </a>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import methodsTabela from './methodsTabela'
import props from './props'

export default {
  props,
  data() {
    return {
      selected: this.value ? this.value : [],
      selectAll: false,
      currentPage: 1,
      elementsPerPage: this.elementsPerPageProp,
      ascending: false,
      sortColumn: '',
      hoverIndex: -1,
      button: [],
      showButton: false,
      showSelected: false,
      ordem: 'asc',
      showButtons: false,
      hoverIndexHeader: -1,
      rowsData: [],
      modoEditar: JSON.parse(localStorage.getItem('optionEdit')),
      htmlArr: [],
      iconArr: [],
      showView: true,
      showEdit: true,
      htmlArrTooltip: [],
      itemsLimit: 30,
      vigenciaArr: [],
      routerName: this.$router.history.current.name
    }
  },
  beforeMount() {
    this.currentPage = this.pagina
    let s = String(this.elementsPerPageProp)
    this.elementsPerPage = s.length < 2 ? `0${s}` : s
    this[this.nameTab]()
  },
  methods: {
    ...methodsTabela,
    permisaoCertificacao(index) {
      if (this.nameTab === 'historico' && !this.vigenciaArr[index]) {
        return false
      }
      return true
    },
    anexar() {
      this.$emit('anexar')
    },
    scrollEvent(event) {
      if (this.itemsLimit >= this.rows.length) return

      const content = event.target
      const showMoreItems = content.scrollHeight - (content.scrollTop + content.clientHeight) < 20

      if (showMoreItems) {
        this.itemsLimit += 5
      }
    },
    ordenaTabela(index) {
      let ordem = this.ordemProp === 'asc' ? 'desc' : 'asc'
      this.$emit('ordena', { index: index, ordem: ordem })
      this.$emit('indexHeader', index)
    },
    emitDeleteSelected() {
      this.$emit('clickButton', { selected: this.selected, type: 'delAll' })
      this.selected = []
      this.selectAll = false
      this.$emit('input', [])
    },
    emitBaixarSelected() {
      this.$emit('clickButton', { selected: this.selected, type: 'downAll' })
      this.selected = []
      this.selectAll = false
      this.$emit('input', [])
    },
    sortTable(col) {
      if (this.sortColumn === col) {
        this.ascending = !this.ascending
      } else {
        this.ascending = true
        this.sortColumn = col
      }

      var ascending = this.ascending

      this.rows.sort(function (a, b) {
        if (a[col] > b[col]) {
          return ascending ? 1 : -1
        } else if (a[col] < b[col]) {
          return ascending ? -1 : 1
        }
        return 0
      })
    },
    num_pages() {
      let pages = []
      let index = this.currentPage

      if (this.qtPaginas === 1) {
        pages = [index]
      } else if (index === 1 && this.qtPaginas === 2) {
        pages = [index, index + 1]
      } else if (index > 1 && this.qtPaginas === 2) {
        pages = [index - 1, index]
      } else if (index > 1 && index + 1 < this.qtPaginas) {
        pages = [index - 1, index, index + 1]
      } else if (index > 0 && index + 1 < this.qtPaginas) {
        pages = [index, index + 1, index + 2]
      } else if (!(index === this.qtPaginas) && this.qtPaginas - index < 2) {
        pages = [index - 1, index, index + 1]
      } else {
        pages = [index - 2, index - 1, index]
      }

      return pages
    },
    change_page(page) {
      if (this.currentPage !== page) {
        this.currentPage = page
        this.selectAll = false
        this.selected = []
        this.$emit('change-page', { currentPage: this.currentPage, elementsPerPage: this.elementsPerPage })
      }
    },
    selectAllChecks() {
      if (!this.selectAll) {
        for (let i in this.rows) {
          const row = this.rows[i]

          if (this.limiteChecks)
            if (this.selected.length == this.limiteChecks) {
              return
            }

          if (!this.selected.includes(this.selectCheckIndex ? i : row.id)) {
            this.selected.push(this.selectCheckIndex ? i : row.id)
          }
        }
      } else {
        this.selected = []
      }
      this.$emit('input', this.selected)
    },
    unselectedAllChecks() {
      this.selectAll = true
      this.selectAllChecks()
    },
    hoverRow(index) {
      this.showButton = true
      this.hoverIndex = index
    },
    downRow() {
      this.hoverIndex = -100
      this.showButton = false
    },
    cleanSelected() {
      // this.selected = []
      this.$emit('input', [])
    },
    showActionsLine(hoverIndex, index) {
      if (this.permisaoCertificacao(index) || this.rotasHabilitas) {
        if (this.disabledButtons.length > 0) {
          if (this.showSelected || this.disabledAllButtons) {
            return false
          } else if (this.selected.length === 1) {
            return this.rows[index].id === this.selected[0]
          }
        } else {
          return false
        }
      }
      return hoverIndex === index
    },
    permicaoUnimedVisualizar(id) {
      if (this.isConsultarUnimed) {
        return this.disabledButtons[0] && this.rows[id].visualizar
      } else {
        return this.disabledButtons[0]
      }
    },
    permicaoUnimedEditar(id) {
      if (this.nameTab === 'historicoPerfil') return this.editar && this.rows[id].editavel
      if (this.nameTab === 'dirigentes') {
        return this.role === 'admin_brasil' || (this.role === 'dirigente' && this.rows[id].medico)
      }

      if (this.isConsultarUnimed) {
        return this.editar && this.disabledButtons[1] && this.rows[id].editar
      } else {
        return this.editar && (this.modoEditar || this.rotasHabilitas) && this.disabledButtons[1]
      }
    },
    isObject(val) {
      return val ? typeof val === 'object' : false
    },
    elementsPerPageFunc() {
      this.selectAll = false
      this.selected = []
      // this.currentPage = 1
      this.$emit('input', [])
      this.$emit('change-element', this.elementsPerPage)
    },
    getValueCheck(index, id) {
      return this.selectCheckIndex ? index : id
    },
    getDisabledCheck(id) {
      if (this.limiteChecks) {
        if (this.selected.includes(id)) return false

        if (this.selected.length == this.limiteChecks) {
          return true
        }
      }
      return !this.editar
    },
    verificaContemAnexos(row) {
      if (row.contemAnexos != null) return row.contemAnexos
    }
  },
  computed: {
    get_rows() {
      return this.rows
    },
    rotasHabilitas() {
      return (
        ['consultarUnimed', 'administracao', 'administracao/novaUnimed', 'dirigentes', 'transacaoOnline'].indexOf(
          this.routerName
        ) > -1
      )
    },
    selectedSizeComputed() {
      return this.selectedSize > 1 ? `${this.selectedSize} Itens selecionados` : `${this.selectedSize} Item selecionado`
    },
    columns() {
      if (this.rows.length === 0) {
        return []
      }
      return Object.keys(this.rows[0])
    },
    mostrandoLength() {
      return this.rows.length < 10 ? `0${this.rows.length}` : this.rows.length
    },
    rowsLength() {
      return Math.ceil(this.qtResultados / this.elementsPerPage)
    },
    selectedSize() {
      return this.selected.length < 10 ? `0${this.selected.length}` : this.selected.length
    },
    showsButtons() {
      if (!this.editar) return false
      return !this.showSelected
    },
    tooltipName() {
      if (this.nameTab === 'anexos' || this.nameTab === 'anexosAdmin') {
        return 'Download'
      } else {
        return 'Recibo'
      }
    }
  },
  watch: {
    value() {
      this.selected = this.value
    },
    selected() {
      this.$emit('selectedElement', this.selected)
      const tamanho = this.botaoSelecionarLixeira ? 1 : 0

      this.showSelected = this.selected.length > tamanho
      this.selectAll = this.selected.length === this.rows.length
    },
    pagina() {
      this.currentPage = this.pagina
    },
    rows() {
      this[this.nameTab]()
    }
  }
}
</script>

<style lang="sass">
@import '@/sass/table.sass'
</style>
